import { makeStyles } from "@material-ui/core/styles";

const cardButtonStyles = makeStyles((theme) => ({
	root: {
		height: "100%"
	},
	card: {
		color: theme.palette.text.primary,
		height: "100%",
		borderRadius: ({ size }) => (size === "small" ? 4 : 8),
		background:
			"linear-gradient(333.43deg, rgba(0,0,0,0.1) 0%, rgba(255,255,255,0.1) 100%)",
		border: ({ active }) =>
			active ? "1px solid #fff" : "1px solid rgba(255,255,255,0.2)"
	},
	cardAction: {
		height: "100%"
	},
	cardContent: {
		height: "100%",
		padding: ({ size, bar, fill }) => {
			if (bar) {
				return "0 12px";
			}
			if (size === "small") {
				return "1vw";
			}
			return fill
				? "min(1.66vw, 20px) min(1.11vw, 14px) min(1.11vw, 14px) min(1.66vw, 20px)"
				: "1.66vw 1.11vw 1.11vw 1.66vw";
		}
	},
	actionText: {
		lineHeight: 1,
		fontWeight: ({ size }) => (size === "small" ? "normal" : "bold"),
		fontSize: ({ size, fill }) => {
			if (size === "small") {
				return "1.11vw";
			}
			// min() keeps the label from outgrowing a card whose height comes
			// from the panel rather than from its own width.
			return fill ? "min(1.4vw, 30px)" : "1.4vw";
		},
		fontFamily: "Overpass",
		[theme.breakpoints.only("xs")]: {
			fontSize: "4vw !important"
		}
	},
	aspectRatioBox: {
		overflow: "hidden",
		height: "100%",
		paddingTop: ({ size, correctionFactor, fill }) => {
			// A filled card takes whatever height its container allocates, so
			// it needs no aspect ratio. This is what lets the Add Play grid fit
			// a bounded panel instead of growing with the viewport width.
			if (fill) {
				return 0;
			}
			let base = 20;
			if (size === "medium") {
				base = 50;
			} else if (size === "large") {
				base = 100;
			}
			// Build the sign explicitly: calc(50% + -16px) is not reliably
			// parsed, and a dropped declaration collapses the card entirely.
			const sign = correctionFactor < 0 ? "-" : "+";
			return `calc(${base}% ${sign} ${Math.abs(correctionFactor)}px)`;
		},
		position: "relative"
	},
	aspectRatioBoxInside: {
		position: "absolute",
		top: 0,
		left: 0,
		width: "100%",
		height: "100%"
	},
	textContainer: {
		display: "flex",
		alignItems: ({ textAlign }) => textAlign,
		justifyContent: ({ textAlign }) => textAlign
	},
	iconContainer: {
		justifyContent: "flex-end",
		justifySelf: "flex-end",
		alignSelf: "flex-end",
		color: theme.palette.gameMode.primary,
		minHeight: "100%"
	},
	barContent: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		height: "100%",
		minWidth: 0,
		overflow: "hidden",
		gap: theme.spacing(3)
	},
	grid: {
		height: "100%",
		alignContent: ({ size }) => {
			return size === "small" ? "center" : "inherit";
		}
	}
}));

export default cardButtonStyles;
